import ApiService from 'src/shared/utils/base-api/api-service';
import {UploadFileDto} from './models/upload-file-dto';
import {ResponseDto} from 'src/shared/common-dtos/response-dto';

class UploadFileService extends ApiService {
  constructor() {
    super({
      baseURL: '/FileManager',
    });
  }

  public uploadFile(input?: FormData): Promise<ResponseDto<UploadFileDto>> {
    return this.post('/UploadFile', input);
  }

  public uploadFilesList(
    input?: any,
  ): Promise<ResponseDto<Array<UploadFileDto>>> {
    return this.post('/UploadFiles', input);
  }

  public deleteFile(url: string): Promise<ResponseDto<UploadFileDto>> {
    return this.delete(`/Delete/${url}`);
  }
}

export const uploadFileService = new UploadFileService();
